
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as guzczDPUrMSYE8L7xp2q0mUvYB323Gcqy61UyO6Z4tG0Meta } from "/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexCN67ZlvzPXuPTeKH3pIN_lyhUzVkzs7vySXWAJioHDcMeta } from "/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchbnBOJhiXz_1dAtGGxAjMHmYrtWrSO2mUYOFumqSLYskMeta } from "/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexE3RgVqE_3JaFBvG87C2A4MCGdUurX6U0AwP8Kn8Gr5AMeta } from "/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93GPrjclgO_Q2KVJb6bwA6AYBb8KP2i_S_45_45cYmif1_45UnoMeta } from "/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index_45IhHSDbqWUomiHXLrajLnZAAY_2yUEKR5K8zzEvTk30Meta } from "/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_934nD_452iURNIpDU6OWgr912GnSHVqO25SBaXgeabJ2X88Meta } from "/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexZKjeuJHTvUurVL7G28PmlC8W_pT3XSYfS9aOquk2XoMMeta } from "/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93cNAAJuDSjZ2SxrnSx9vl0pJv5FPmoym_45yHHOzc3x_45jMMeta } from "/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexeF4Sy_45IM0RTT0_reqMuAC_45sJcONR3LOUTSyNg1RKVwoMeta } from "/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexQhpQa85UU2ApQ4e8b0GZDISV_kmcKpqkdtdiBeSq5GAMeta } from "/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index_45IhHSDbqWUomiHXLrajLnZAAY_2yUEKR5K8zzEvTk30Meta || {},
    component: () => import("/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexZKjeuJHTvUurVL7G28PmlC8W_pT3XSYfS9aOquk2XoMMeta || {},
    component: () => import("/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexeF4Sy_45IM0RTT0_reqMuAC_45sJcONR3LOUTSyNg1RKVwoMeta || {},
    component: () => import("/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexQhpQa85UU2ApQ4e8b0GZDISV_kmcKpqkdtdiBeSq5GAMeta || {},
    component: () => import("/codebuild/output/src3801009948/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]